
function dashboard(data) {
    if (data.status == 'active') {
        var verified = getUrlParam('verified');
        if (verified) {
            showResult(_accountactivated, 'success', { duration: 6000 });
        }
    } else {
        showResult(_emailverifydashboard, 'warning');
        _dashbuttons.prepend(`<a class="uppresend btn-main btn-lg ${upp_assets.buttons.primary_btn}">${_resendverify}<span class="fas fa-chevron-right"></span></a>`);
    }

    _dashbuttons.fadeIn(300);

    $('.btn-help').attr('href',helpurl);
    $('.btn-help').html(`${_helpcenter} <span class="fas fa-chevron-right"></span>`);

    if (ultra_settings.theme != 'passport') {
        $('.btn-help').attr('target','_blank');
    }

    if(data) {

        $('#ppnav').html(ppdashnav);

        if(ultra_settings.theme == 'ibiza') {
            $('.myitems').find('.gray-btn').addClass('red-outline-btn').removeClass('.gray-btn');

        }

        $('#ppnav li a').on('click', function(event) {

            event.preventDefault();

            var el = $(this);

            if(el.hasClass('active')) {
                return;
            }

            $("#ppnav li a.active").removeClass("active");
            el.addClass("active");
            $(".ptab").hide();

            var activeTab = el.attr("href");
            window.location.hash = activeTab;
            activeTab = activeTab.replace('#','');
            activeTab = `#upp${activeTab}`;
            $(activeTab).fadeIn();


            var title = el.data("title");
            $('.dtitle').text(title);

            return false;


        });


        setTimeout(function(){
            $('#ppnav, .dashboard .guesthide').fadeIn(300);
        },300)

        qualifyTable();
        benefitsTable();

    }


    $(window).bind( 'hashchange', function(e) {
        $(`#ppnav li a[href="${window.location.hash}"]`).trigger('click');
    });

    if(data.points_history && data.points_history.length) {
        $.each( data.points_history, function( key, val ) {

            if(val.id) {

                var dateformat = 'MMMM D, YYYY';
                var deldate = '';
                var created_by = '';
                var deleted_by = '';
                var logo = upp_assets.images.logo;
                var website = '';
                var delclass = '';
                var deleted = false;
                var description = '';
                var event = '';
                var type = '';
                var active_year = '';
                var expired = false;
                var code = '';
                var alt = '';
                var calcamount = Number(val.amount).toLocaleString();
                var entrydate = moment(val.created_at).format(dateformat);
                var expiresdate = moment(val.expires_at).format(dateformat);

                if (val.deleted_at) {
                    deleted = true;
                } else {
                    deldate = '<li>&nbsp;</li>';
                    delcamount = `<span>${calcamount}</span>`;
                }

                if ( val.expired ) {
                    expired = true;
                }

                event = val.event || '';
                code = val.code;

                description = (typeof(pointcodes[code]) == 'undefined' ? val.description : pointcodes[code]);

                //TODO: Fix this
                getEventJSON()
                .done(function(data) {

                    $.each( data, function( key, val ) {

                        if(event == val.code){

                            if (val.media.white_logo) {
                                logo = val.media.white_logo;
                            }
                            if (val.type) {
                                type = val.type;
                            }
                            if (val.title) {
                                title = val.title;
                            }
                            if (val.active_year) {
                                active_year = val.active_year;
                            }
                            alt = `${type} ${title} ${active_year}`;
                            if (val.url) {
                                website = val.url;
                            } else {
                                website = '#';
                            }
                            if (val.type == 'RTU') {
                                description = (typeof(pointcodes['attend_rtu']) == 'undefined' ? 'attend_rtu' : pointcodes['attend_rtu']);
                            }
                            if (val.type == 'Resistance') {
                                description = (typeof(pointcodes['attend_resistance']) == 'undefined' ? 'attend_resistance' : pointcodes['attend_resistance']);
                            }
                        }

                    });

                    logo = `<a href="${website}" target="blank"><img src="${logo}" alt="${alt}" width="150" style=""></a>`;

                    if(deleted) {

                        delclass = 'deletedpoints';
                        deldate = moment(val.deleted_at).format(dateformat)

                        delcamount = `<span>${calcamount}</span>`;
                        deldate = `<span>${entrydate}</span>`;

                        output = `
                        <div class="entry ${delclass}">
                            <ul>
                                <li>${logo}</li>
                                <li class="created"><div class="lbreak3 op50 mb2"></div></li>
                                <li class="amount">&ndash; <strong>${delcamount}</strong><div class="lbreak3 op50"></div></li>
                                <li class="description">${deldate}<br>${description}</li>
                            </ul>
                        </div>`;
                        $('#ledger').append(output);
                        return;
                    }

                    output = `
                    <div class="entry">
                        <ul>
                            <li>${logo}</li>
                            <li class="created"><div class="lbreak3 op50 mb2"></div></li>
                            <li class="amount">+ <strong>${calcamount}</strong><div class="lbreak3 op50"></div></li>
                            <li class="description">${entrydate}<br>${description}</li>
                        </ul>
                    </div>`;

                    $('#ledger').append(output);

                    var website = website || '';
                    var title = title || '';
                    var type = type || '';

                    var rowclass = 'active';
                    var symbol = '';
                    var related_event = '';
                    if ( deleted ) {
                        rowclass = 'deleted';
                        //var symbol = '&ndash;';
                    }
                    if ( expired ) {
                        rowclass = 'expired';
                        //var symbol = '&ndash;';
                    }
                    if ( ! title ) {
                        related_event = 'no-event';
                    }

                    output = `
                    <tr class="${rowclass}">
                        <td class="${related_event}"><strong class="label">Event</strong> <span class="entry-details">${type} ${title}</span></td>
                        <td><strong class="label">Activity</strong> <span class="entry-details">${description}</span></td>
                        <td><strong class="label">Points</strong> <span class="entry-details"> <strong>${symbol} ${calcamount}</strong> </span></td>
                        <td><strong class="label">Earned</strong> <span class="entry-details">${entrydate}</span></td>
                        <td><strong class="label">Expires </strong> <span class="entry-details">${expiresdate}</span></td>
                    </tr>`;

                    $('#points-ledger tbody').append(output);

                })

}

$('.activepoints').text(_active);
$('.deletedpoints').text(_expired);

});

} else {
    $('#ledger').append('<div class="entry"><ul><li>You have not earned any points yet.</li></ul></div>');
}



}

$(document).on('click', '.uppresend', function(e){
    e.preventDefault();
    sendVerify(upp_page.verify);
})




function qualifyTable() {

    $.get( `https://ultrapassport.com/app-feed?site=${ultra_settings.site_url}` , function() {})
    .done(function(data) {

        var points = $('#qualifytable');
        var bonus = $('#bonustable');

        var tableheaderhtml = `<thead><tr><td>${data.earn.labels.action}</td><td align="center" width="50">${data.earn.labels.points}</td></tr></thead>`
        points.html(tableheaderhtml);

        var tableheaderhtml = `<thead><tr><td>${data.earn.labels.bonus}</td><td align="center" width="50">${data.earn.labels.points}</td></tr></thead>`
        bonus.html(tableheaderhtml);

        var rows = '<tbody>'
        $.each( data.earn.actions, function( key, val ) {

            var qtext = '';
            //rows += '<tr><td><p>'+qtext+'</td><td align="center"><strong>+'+Number(val[1]).toLocaleString()+'</strong></p></td></tr>';

            var desc = '';
            if ( val.description && val.description.length ) {
                desc = `
                <p>${val.title}<a href="#" data-src="#action-${key}>" data-fancybox=""><i class="fas fa-circle-question"></i></a></p>
                <div class="hide">
                    <div id="action-${key}" class="description">
                        <div>
                            <h4 class="title">${val.title}</h4>
                            <hr class="op50">
                            ${val.description}
                        </div>
                    </div>
                </div>`;
            } else {
                desc = `<p>${val.title}</p>`;
            }

            rows += `
            <tr data-name="points-${key}"><td>${desc}</td>
                <td><h3 class="points text-right mt0 mb0">${val.amount}</h3></td>
            </tr>`;

        });
        rows += '</tbody>';
        points.append(rows);


        var rows = '<tbody>'
        $.each( data.earn.bonuses, function( key, val ) {

            var qtext = '';

            var desc = '';
            if ( val.description && val.description.length ) {
                desc = `
                <p>${val.title}<a href="#" data-src="#bonus-${key}>" data-fancybox=""><i class="fas fa-circle-question"></i></a></p>
                <div class="hide">
                    <div id="bonus-${key}" class="description">
                        <div>
                            <h4 class="title">${val.title}</h4>
                            <hr class="op50">
                            ${val.description}
                        </div>
                    </div>
                </div>`;
            } else {
                desc = `<p>${val.title}</p>`;
            }

            rows += `
            <tr data-name="points-${key}"><td>${desc}</td>
                <td><h3 class="points text-right mt0 mb0">${val.amount}</h3></td>
            </tr>`;

        });
        rows += '</tbody>';
        bonus.append(rows);

        $('.earn-text').html(data.earn.content);

        fillEvents();

    });


}


function benefitsTable() {

    $.get( `https://ultrapassport.com/app-feed?site=${ultra_settings.site_url}` , function() {})
    .done(function(data) {

        var table = $('#benefitstable');

        var tableheaderhtml = `<thead><tr><td>${data.benefits.labels.benefits}</td><td align="center" width="30">${data.benefits.labels.silver}</td><td align="center" width="30">${data.benefits.labels.gold}</td ><td align="center" width="30">${data.benefits.labels.platinum}</td></tr></thead>`
        table.html(tableheaderhtml);

        var rows = '<tbody>'

        $.each( data.benefits.benefits, function( key, val ) {
            if ( val.level == 1) {
                var desc = '';
                if ( val.description && val.description.length ) {
                    desc = `
                    <p>${val.title}<a href="#" data-src="#benefit-${key}>" data-fancybox=""><i class="fas fa-circle-question"></i></a></p>
                    <div class="hide">
                        <div id="benefit-${key}" class="description">
                            <div>
                                <h4 class="title">${val.title}</h4>
                                <hr class="op50">
                                ${val.description}
                            </div>
                        </div>
                    </div>`;
                } else {
                    desc = `<p>${val.title}</p>`;
                }
                rows += `<tr><td>${desc}</td><td><span class="silveru uicon"></span></td><td><span class="goldu uicon"></span></td><td><span class="platinumu uicon"></span></td></tr>`;
            }
        });
        $.each( data.benefits.benefits, function( key, val ) {
            if ( val.level == 2) {
                if ( val.description && val.description.length ) {
                    desc = `
                    <p>${val.title}<a href="#" data-src="#benefit-${key}>" data-fancybox=""><i class="fas fa-circle-question"></i></a></p>
                    <div class="hide">
                        <div id="benefit-${key}" class="description">
                            <div>
                                <h4 class="title">${val.title}</h4>
                                <hr class="op50">
                                ${val.description}
                            </div>
                        </div>
                    </div>`;
                } else {
                    desc = `<p>${val.title}</p>`;
                }
                rows += `<tr><td>${desc}</td><td></td><td><span class="goldu uicon"></span></td><td><span class="platinumu uicon"></span></td></tr>`;
            }
        });
        $.each( data.benefits.benefits, function( key, val ) {
            if ( val.level == 3) {
                if ( val.description && val.description.length ) {
                    desc = `
                    <p>${val.title}<a href="#" data-src="#benefit-${key}>" data-fancybox=""><i class="fas fa-circle-question"></i></a></p>
                    <div class="hide">
                        <div id="benefit-${key}" class="description">
                            <div>
                                <h4 class="title">${val.title}</h4>
                                <hr class="op50">
                                ${val.description}
                            </div>
                        </div>
                    </div>`;
                } else {
                    desc = `<p>${val.title}</p>`;
                }
                rows += `<tr><td>${desc}</td><td></td><td></td><td><span class="platinumu uicon"></span></td></tr>`;
            }
        });

        rows += '</tbody>';

        table.append(rows);

        $('.benefits-text').html(data.benefits.content);

    });

}
